"use client";

import { useEffect, useRef } from "react";

import { clearStoredPaywallContext } from "@/lib/analytics";

export default function SubscriptionUpgradedTracker() {
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (hasFiredRef.current) return;
    hasFiredRef.current = true;

    try {
      clearStoredPaywallContext();
    } catch {}
  }, []);

  return null;
}
